export const generateSvg = (
  key: string,
  icon: string,
  size: number = 16,
): string => {
  return `<button
           class="e-tbar-btn e-btn custom-toolbar-button ${key.toLowerCase().trim().split(' ').join('-')}"
            tabindex="-1"
          >
            <div class="e-tbar-btn-text" style="font-weight: 500">
              <span class="e-btn-icon ${icon}"></span>
            </div>
          </button>`
}
